const shopPageES = {
	errorLoading: "No pudimos cargar este negocio. Inténtalo de nuevo.",
	rating: {
		reviews: "{{count}} reseñas",
	},
	searchServices: "Buscar servicios",
	status: {
		open: "Abierto",
		closed: "Cerrado",
		until: "hasta las",
		opensAt: "abre",
		tomorrow: "mañana",
	},
	gallery: {
		back: "Volver",
		share: "Compartir",
		linkCopied: "Enlace copiado",
		noPhotos: "Aún no hay fotos",
		photo: "Foto",
		photos: "fotos",
		photosOne: "foto",
		previous: "Anterior",
		next: "Siguiente",
		close: "Cerrar",
	},
	main: {
		services: "Servicios",
		book: "Reservar",
		noServices: "No hay servicios disponibles.",
		reviews: "Reseñas",
		noReviews: "Aún no hay reseñas",
		attributes: "Atributos",
		noAttributes: "Aún no hay atributos",
		info: "Información",
		about: "Acerca del negocio",
		searchServices: "Buscar un servicio",
		anonymous: "Anónimo",
		newShop: "Nuevo en Sin Fila",
		reportReview: "Reportar reseña",
		serviceType: {
			home: "A domicilio",
			online: "En línea",
		},
	},
	sidebar: {
		description: "Descripción",
		location: "Ubicación",
		information: "Información",
		staff: "Personal",
		contactAndHours: "Contacto y Horarios",
		noPhone: "Teléfono no disponible",
		call: "Llamar",
		getDirections: "Cómo llegar",
		hours: {
			title: "Horarios",
			today: "Hoy",
			closed: "Cerrado",
			showWeek: "Ver semana completa",
			hideWeek: "Ocultar semana",
		},
		websiteTitle: "Sitio web",
		socialTitle: "Redes Sociales",
	},
};

export default shopPageES;
